module.exports = __webpack_public_path__ + "static/media/gallery1.81863baf.png";